export function filterDate() {
  const dateInput = document.getElementById("filter_beginndat");

  if (!dateInput) return;
  // 2. Event-Listener hinzufügen, wenn das Feld fokussiert wird (angeklickt)
  dateInput.addEventListener("focus", function () {
    // Schaltet den Typ auf 'date', um den Browser-Kalender zu öffnen
    this.type = "date";
    // Wenn ein Wert vorhanden ist, muss dieser gesetzt bleiben, damit er im Kalender erscheint
    if (this.value) {
      this.value = this.value;
    }
  });

  // 3. Event-Listener hinzufügen, wenn der Fokus das Feld verlässt (nach Auswahl)
  dateInput.addEventListener("blur", function () {
    // Prüft, ob ein Wert ausgewählt wurde
    if (!this.value) {
      // Wenn kein Wert ausgewählt wurde, schaltet es zurück auf 'text',
      // damit der Placeholder wieder sichtbar wird.
      this.type = "text";
    }
  });

  const currentValue = dateInput.value;

  // Konvertiert von ISO (YYYY-MM-DD) zu DE (TT.MM.JJJJ)
  function convertToDeFormat(isoDate) {
    if (!isoDate) return "";
    // Prüft, ob der Wert das ISO-Format YYYY-MM-DD hat
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
      const parts = isoDate.split("-"); // ['YYYY', 'MM', 'DD']
      return `${parts[2]}.${parts[1]}.${parts[0]}`; // DD.MM.YYYY
    }
    return isoDate; // Gibt den Wert unverändert zurück, wenn er bereits im DE-Format ist oder leer.
  }

  // --- AUSFÜHRUNG BEIM LADEN DER SEITE ---

  // Nur formatieren, wenn ein Wert vorhanden ist
  if (currentValue) {
    dateInput.value = convertToDeFormat(currentValue);
  }
}
